
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWhatsappApp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 33,
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#whatsapp-app_b238efc0c63115ee__a)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#whatsapp-app_b238efc0c63115ee__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.808 19.943 4.12 26.075l6.303-1.646a11.924 11.924 0 0 0 5.68 1.44h.006c6.552 0 11.886-5.308 11.89-11.832a11.732 11.732 0 0 0-3.48-8.37 11.843 11.843 0 0 0-8.41-3.47c-6.553 0-11.886 5.307-11.889 11.831 0 2.085.547 4.121 1.587 5.915Zm5.269 2.557-.361-.213-3.74.976.998-3.629-.235-.371a9.777 9.777 0 0 1-1.51-5.234c.001-5.422 4.434-9.834 9.885-9.834A9.839 9.839 0 0 1 23.1 7.08a9.752 9.752 0 0 1 2.891 6.958c-.002 5.422-4.434 9.834-9.881 9.834h-.004a9.9 9.9 0 0 1-5.03-1.37Z",
  fill: "#B3B3B3"
})), /*#__PURE__*/React.createElement("path", {
  d: "m4 25.953 1.687-6.132A11.77 11.77 0 0 1 4.1 13.906C4.103 7.382 9.436 2.074 15.989 2.074a11.843 11.843 0 0 1 8.41 3.47 11.732 11.732 0 0 1 3.479 8.371c-.003 6.524-5.337 11.833-11.89 11.833h-.004c-1.99-.001-3.945-.498-5.681-1.44L4 25.952Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.991 4.073c-5.45 0-9.884 4.412-9.886 9.834a9.777 9.777 0 0 0 1.511 5.234l.235.372-.998 3.629 3.74-.977.361.213a9.903 9.903 0 0 0 5.03 1.372h.003c5.447 0 9.88-4.412 9.882-9.835a9.75 9.75 0 0 0-2.892-6.958 9.838 9.838 0 0 0-6.986-2.884Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.991 4.073c-5.45 0-9.884 4.412-9.886 9.834a9.777 9.777 0 0 0 1.511 5.234l.235.372-.998 3.629 3.74-.977.361.213a9.902 9.902 0 0 0 5.03 1.372h.003c5.447 0 9.88-4.412 9.882-9.835a9.75 9.75 0 0 0-2.892-6.958 9.838 9.838 0 0 0-6.986-2.884Z",
  fill: "url(#whatsapp-app_b238efc0c63115ee__c)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.019 8.96c-.223-.493-.457-.503-.668-.512l-.57-.007c-.198 0-.52.074-.792.37s-1.04 1.012-1.04 2.467 1.065 2.86 1.213 3.058c.148.198 2.055 3.279 5.075 4.464 2.509.986 3.02.79 3.564.74.545-.049 1.758-.715 2.005-1.406.248-.69.248-1.282.174-1.406-.074-.123-.273-.197-.57-.345-.297-.148-1.757-.863-2.03-.962-.272-.099-.47-.148-.668.148-.198.296-.767.962-.94 1.16-.174.197-.347.222-.644.074-.297-.148-1.254-.46-2.39-1.468-.882-.784-1.478-1.752-1.652-2.048-.173-.296-.018-.456.13-.603.134-.133.298-.346.447-.518.148-.173.197-.296.296-.493.1-.197.05-.37-.024-.518-.075-.148-.652-1.61-.916-2.196",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "whatsapp-app_b238efc0c63115ee__a",
  x: 0,
  y: 0.074,
  width: 32,
  height: 32,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_9466_1604"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_9466_1604",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "whatsapp-app_b238efc0c63115ee__b",
  x: 1.925,
  y: 0,
  width: 28.271,
  height: 28.27,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.098,
  result: "effect1_foregroundBlur_9466_1604"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "whatsapp-app_b238efc0c63115ee__c",
  x1: 7.341,
  y1: 5.304,
  x2: 7.441,
  y2: 22.119,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#57D163"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23B33A"
})))));

      const __svgRaw = "<svg width=\"32\" height=\"33\" viewBox=\"0 0 32 33\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<g filter=\"url(#filter0_d_9466_1604)\">\r\n<g filter=\"url(#filter1_f_9466_1604)\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.80789 19.9434L4.12109 26.0747L10.4236 24.4293C12.1601 25.372 14.1152 25.8689 16.1048 25.8697H16.1099C22.6624 25.8697 27.9962 20.5611 27.9991 14.0375C28.0002 10.8758 26.7651 7.90303 24.5202 5.6665C22.2752 3.42997 19.2903 2.1979 16.1101 2.19629C9.55667 2.19629 4.2237 7.50392 4.22095 14.028C4.22031 16.1135 4.7676 18.1491 5.80789 19.9434ZM11.0767 22.5002L10.7156 22.2872L6.97567 23.2634L7.9741 19.6345L7.739 19.2626C6.74939 17.6949 6.22565 15.8804 6.22833 14.0288C6.23027 8.6065 10.6631 4.19506 16.1138 4.19506C18.7359 4.18892 21.2515 5.22743 23.0998 7.07907C24.9655 8.93788 25.9924 11.409 25.9914 14.0367C25.9891 19.4594 21.5565 23.8713 16.1099 23.8713H16.1062C14.3327 23.8705 12.5935 23.3964 11.0767 22.5002Z\" fill=\"#B3B3B3\"/>\r\n</g>\r\n<path d=\"M4 25.9526L5.68679 19.8213C4.64471 18.0227 4.09734 15.9823 4.09986 13.906C4.10261 7.38185 9.43558 2.07422 15.989 2.07422C19.1692 2.07583 22.1542 3.3079 24.3991 5.54443C26.644 7.78096 27.8791 10.7538 27.878 13.9154C27.8751 20.4391 22.5413 25.7477 15.9888 25.7477H15.9837C13.9941 25.7469 12.039 25.2499 10.3025 24.3073L4 25.9526Z\" fill=\"white\"/>\r\n<path d=\"M15.991 4.07327C10.5402 4.07327 6.10742 8.48471 6.10548 13.907C6.10279 15.7586 6.62653 17.5731 7.61614 19.1408L7.85125 19.5128L6.85281 23.1417L10.5929 22.1654L10.954 22.3784C12.4708 23.2746 14.21 23.7487 15.9835 23.7497H15.9873C21.4338 23.7497 25.8666 19.3377 25.8687 13.9151C25.877 11.3045 24.8358 8.79906 22.9771 6.95745C21.1288 5.1057 18.6132 4.06713 15.991 4.07327Z\" fill=\"black\"/>\r\n<path d=\"M15.991 4.07327C10.5402 4.07327 6.10742 8.48471 6.10548 13.907C6.10279 15.7586 6.62653 17.5731 7.61614 19.1408L7.85125 19.5129L6.85281 23.1417L10.5929 22.1654L10.954 22.3784C12.4708 23.2746 14.21 23.7485 15.9835 23.7495H15.9873C21.4338 23.7495 25.8666 19.3376 25.8687 13.9149C25.877 11.3043 24.8358 8.7989 22.9771 6.95728C21.1288 5.1056 18.6131 4.06709 15.991 4.07327Z\" fill=\"url(#paint0_linear_9466_1604)\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.019 8.95924C12.7964 8.46682 12.5621 8.45685 12.3505 8.44832L11.7811 8.44141C11.583 8.44141 11.2611 8.5154 10.989 8.8114C10.7169 9.10739 9.94922 9.82277 9.94922 11.2778C9.94922 12.7328 11.0137 14.1388 11.1621 14.3364C11.3104 14.5339 13.2171 17.615 16.2367 18.8004C18.7459 19.7856 19.2566 19.5896 19.8014 19.5404C20.3463 19.4912 21.559 18.825 21.8064 18.1344C22.0538 17.4438 22.0539 16.8522 21.9798 16.7284C21.9056 16.6047 21.7075 16.5312 21.4102 16.3832C21.1129 16.2352 19.6526 15.5199 19.3803 15.4211C19.1081 15.3223 18.9101 15.2732 18.7118 15.5692C18.5136 15.8652 17.945 16.5311 17.7716 16.7284C17.5982 16.9258 17.4251 16.9506 17.1278 16.8028C16.8305 16.6549 15.8739 16.3425 14.7389 15.335C13.8559 14.5511 13.2598 13.583 13.0862 13.2872C12.9127 12.9914 13.0678 12.8311 13.2168 12.6838C13.3501 12.5512 13.5138 12.3384 13.6626 12.1658C13.8114 11.9932 13.8604 11.8698 13.9593 11.6727C14.0582 11.4757 14.0089 11.3026 13.9346 11.1547C13.8602 11.0069 13.2831 9.54431 13.019 8.9594\" fill=\"white\"/>\r\n</g>\r\n<defs>\r\n<filter id=\"filter0_d_9466_1604\" x=\"0\" y=\"0.0742188\" width=\"32\" height=\"32\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n<feOffset dy=\"2\"/>\r\n<feGaussianBlur stdDeviation=\"2\"/>\r\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0\"/>\r\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_9466_1604\"/>\r\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_9466_1604\" result=\"shape\"/>\r\n</filter>\r\n<filter id=\"filter1_f_9466_1604\" x=\"1.92492\" y=\"0.000111818\" width=\"28.2713\" height=\"28.2703\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"BackgroundImageFix\" result=\"shape\"/>\r\n<feGaussianBlur stdDeviation=\"1.09809\" result=\"effect1_foregroundBlur_9466_1604\"/>\r\n</filter>\r\n<linearGradient id=\"paint0_linear_9466_1604\" x1=\"7.34144\" y1=\"5.3039\" x2=\"7.44075\" y2=\"22.1185\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"#57D163\"/>\r\n<stop offset=\"1\" stop-color=\"#23B33A\"/>\r\n</linearGradient>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/whatsapp-app.b238efc0c63115ee58f1e0e9763025b3.svg"),
        {
          React: SvgWhatsappApp,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      